import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

export default function UserProfilePage() {
  const { username } = useParams();
  const [profile, setProfile] = useState(null);
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await fetch(`/users/${username}`);
        const data = await res.json();
        setProfile(data);
      } catch (err) {
        console.error("Erreur profil:", err);
      }
    };

    const fetchVideos = async () => {
      try {
        const res = await fetch(`/users/${username}/videos`);
        const data = await res.json();
        setVideos(data);
      } catch (err) {
        console.error("Erreur vidéos:", err);
      }
    };

    Promise.all([fetchProfile(), fetchVideos()]).then(() => setLoading(false));
  }, [username]);

  const isImage = (filePath) =>
    /\.(jpg|jpeg|png|gif|webp)$/i.test(filePath);

  const getMediaPath = (media) => {
    const basePath = media.source === 'media' ? '/uploads/' : '/uploads/';
    return basePath + media.file_path;
  };

  if (loading) return <div className="container py-5 text-center">Chargement...</div>;
  if (!profile) return <div className="container py-5 text-center text-danger">Utilisateur introuvable</div>;

  return (
    <div className="container py-5">
      <div className="card shadow-sm mb-5">
        {profile.cover_url && (
          <img src={profile.cover_url} className="card-img-top" alt="Couverture" style={{ height: 200, objectFit: 'cover' }} />
        )}
        <div className="card-body text-center">
          <img
            src={profile.avatar_url}
            alt={profile.display_name}
            className="rounded-circle mb-3"
            style={{ width: 100, height: 100, objectFit: 'cover', border: '3px solid #fff', marginTop: -50 }}
          />
          <h4 className="mb-0">{profile.display_name}</h4>
          <p className="text-muted">{profile.handle}</p>
          <p className="mt-2">{profile.bio}</p>
          <div className="d-flex justify-content-center gap-4 mt-3 text-muted">
            <div><strong>{profile.followers}</strong> abonnés</div>
            <div><strong>{profile.following}</strong> abonnements</div>
            <div><strong>{profile.monthly_views}</strong> vues/mois</div>
          </div>
        </div>
      </div>

      <h5 className="mb-3">📽️ Médias publiques partagés</h5>
      <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-4">
        {videos.length === 0 && <p className="text-muted">Aucun média publié pour le moment.</p>}
        {videos.map((media) => {
          const src = getMediaPath(media);
          return (
            <div className="col" key={media.id}>
              <div className="card h-100 shadow-sm">
                <div className="position-relative" style={{ paddingBottom: '56.25%', height: 0 }}>
                  {isImage(media.file_path) ? (
                    <img
                      src={src}
                      alt={media.title}
                      className="w-100 h-100 position-absolute top-0 start-0 object-fit-cover"
                    />
                  ) : (
                    <video
                      src={src}
                      controls
                      className="w-100 h-100 position-absolute top-0 start-0 object-fit-cover"
                    />
                  )}
                </div>
                <div className="card-body">
                  <h6 className="fw-bold text-truncate" title={media.title}>{media.title || 'Sans titre'}</h6>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
